import React, { useEffect, useRef, useState } from "react";
import { Copy, Check } from "lucide-react";
import { Button } from "../ui/button";
import "./product-lookup.css";

const Article = ({ productId, field, label, value }) => {
  const text = value == null ? "" : String(value).trim();
  const [state, setState] = useState("");
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const copy = async () => {
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(text);
      else {
        const el = document.createElement("textarea");
        el.value = text; el.style.position = "fixed"; el.style.opacity = "0";
        document.body.appendChild(el);
        let success;
        try { el.select(); success = document.execCommand("copy"); }
        finally { el.remove(); }
        if (!success) throw new Error("Clipboard unavailable");
      }
      setState("copied");
    } catch { setState("error"); }
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setState(""), 2500);
  };
  return <div className="product-article-row" data-testid={`product-article-row-${field}-${productId}`}>
    <span className="product-article-label">{label}</span>
    <span className="product-article-value" data-testid={`product-article-${field}-${productId}`}>{text || "Не указан"}</span>
    <Button type="button" variant="ghost" size="icon" className="product-article-copy" disabled={!text}
      data-testid={`product-copy-${field}-${productId}`} onClick={copy}
      title={state === "copied" ? "Скопировано" : `Копировать ${label}`}
      aria-label={state === "copied" ? `${label} скопирован` : `Копировать ${label}`}>
      {state === "copied" ? <Check size={14} /> : <Copy size={14} />}
    </Button>
    {state && <span role="status" className={`product-article-feedback ${state}`} data-testid={`product-copy-status-${field}-${productId}`}>
      {state === "copied" ? "Скопировано" : "Не удалось скопировать — выделите артикул вручную"}
    </span>}
  </div>;
};

export const ProductArticles = ({ product }) => <div className="product-articles" data-testid={`product-articles-${product.id}`}>
  <Article productId={product.id} field="our-sku" label="SKU" value={product.our_sku} />
  <Article productId={product.id} field="factory-sku" label="Фабричный" value={product.sku} />
</div>;